import React from 'react'
import intl from 'react-intl-universal';

import { CheckCircleFill, ClockCircleOutline, ExclamationCircleOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs';

import pendingIcon from '../../../assets/images/icon/icon_pending.png'
import receivedIcon from '../../../assets/images/icon/icon_receive.png'
import deliveringIcon from '../../../assets/images/icon/icon_deliver.png'



import './index.less'

export default function OrderStatus({ status, time, showIconCard = false }) {
    const statusInt = parseInt(status);

    let cls = '',
        txt = '',
        icon = '',
        color = '#00a88b'
    switch (statusInt) {
        case 1:
            cls = 'status-pending'
            txt = intl.get('pendingReceive').d('待接单');
            icon = <img src={pendingIcon} alt='icon' className='status-icon' />
            color = '#f7b500'
            break;
        case 2:
            cls = 'status-wait-pay'
            txt = intl.get('to_be_paid').d('待支付');
            icon = <img src={pendingIcon} alt='icon' className='status-icon' />
            color = '#f7b500'
            break;
        case 10:
            cls = 'status-reject'
            txt = intl.get('rejectReceive').d('拒绝接单');
            icon = <ExclamationCircleOutline fontSize={40} color='#FF9800' />
            color = '#FF9800'
            break;
        case 11:
            cls = 'status-cancel'
            txt = intl.get('has_canceled').d('取消');
            icon = <ExclamationCircleOutline fontSize={40} color='#555' />
            color = '#555'
            break;
        case 20:
            cls = 'status-received'
            txt = intl.get('receivedOrder').d('已接单');
            icon = <img src={receivedIcon} alt='icon' className='status-icon' />
            break;
        case 21:
            cls = 'status-delivering'
            txt = intl.get('delivering').d('已出餐');
            icon = <ClockCircleOutline fontSize={40} color='#00a88b' />
            break;
        case 22:
            cls = 'status-delivered'
            txt = intl.get('delivered').d('已送达');
            icon = <img src={deliveringIcon} alt='icon' className='status-icon' />
            break;
        case 30:
            cls = 'status-closed'
            txt = intl.get('closed').d('关闭');
            icon = <ExclamationCircleOutline fontSize={40} color='#555' />
            color = '#555'
            break;
        case 40:
            cls = 'status-completed'
            txt = intl.get('completed').d('已完成');
            icon = <CheckCircleFill fontSize={40} color='#00a88b' />
            break;
    }
    return (
        showIconCard ?
            <div className={`od-status-card text-center`}>
                <div className='od-status-icon'>
                    {icon}
                </div>
                <div className='od-status-text m-t-sm'><span style={{ color }}>{txt}</span></div>
                <div className='od-status-time'>{dayjs(time).format('YYYY-MM-DD HH:mm')}</div>
            </div>
            :
            <div className={`order-card-status ${cls}`}>{txt}</div>
    )
}
